import React from 'react';
import PropTypes from 'prop-types';

import WithGlobalUserInfo from './WithGlobalUserInfo';

const propTypes = {
    user: PropTypes.object,
    className: PropTypes.string
};

const defaultProps = {
    user: {},
    className: ''
};

function UserFullName({ user, className }) {
    return <span className={className}>{user.first_name} {user.last_name}</span>;
}

UserFullName.propTypes = propTypes;
UserFullName.defaultProps = defaultProps;

export default WithGlobalUserInfo(UserFullName);